<template>
  <v-dialog v-model="show" max-width="800">
    <v-card>
      <v-card-title class="body-1">
        {{ $vuetify.lang.t('$vuetify.CONTROLLERS.FIRMWARE_UPDATE') }}
        <v-spacer></v-spacer>
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div>
          <h3>{{ $vuetify.lang.t('$vuetify.INFORMATION') }}!</h3>
          <span>
            {{
              $vuetify.lang.t(
                '$vuetify.CONTROLLERS.OTA_NOTIFICATION_DESCRIPTION'
              )
            }}
          </span>
        </div>
        <v-select
          v-model="selectedFirmware"
          :items="controllerFirmwareList"
          item-text="FirmwareVersion"
          return-object
          :label="$vuetify.lang.t('$vuetify.CONTROLLERS.FIRMWARE_VERSION')"
          @focus="getControllerFirmwareList(placeId)"
        ></v-select>
        <div
          v-if="
            selectedFirmware.FirmwareVersion &&
              selectedFirmware.FirmwareVersion !== ''
          "
          class="col-xs-12 mt-3 mb-3"
        >
          <strong
            ><span class="mb-1"
              >{{
                $vuetify.lang.t(
                  '$vuetify.CONTROLLERS.FIRMWARE_VERSION_INFORMATION_TITLE'
                )
              }}:</span
            ></strong
          >
          <br />
          <span
            >{{ $vuetify.lang.t('$vuetify.CONTROLLERS.VERSION') }}:
            {{ selectedFirmware.FirmwareVersion }}</span
          >
          <br />
          <span>
            {{ $vuetify.lang.t('$vuetify.CONTROLLERS.FIRMWARE') }} URL:
            <a style="color: #007CAD;" :href="selectedFirmware.Url">{{
              selectedFirmware.Url
            }}</a>
          </span>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="show = false">
          {{ $vuetify.lang.t('$vuetify.CANCEL') }}
        </v-btn>
        <v-btn
          :disabled="!selectedFirmware.FirmwareVersion || !selectedFirmware.Url"
          color="primary"
          class="secondary--text"
          @click="updateFirmware()"
        >
          {{ $vuetify.lang.t('$vuetify.CONTROLLERS.UPDATE_FIRMWARE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import formatDate from '@/mixins/formatDate'

export default {
  name: 'ControllerFirmwareUpdateDialog',
  mixins: [formatDate],
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    controller: {
      type: Object,
      required: false
    },
    placeId: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      selectedFirmwareVersion: 3,
      selectedFirmware: {}
    }
  },
  computed: {
    ...mapGetters('app', ['loading']),
    ...mapGetters('places', ['controllerFirmwareList']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          //   this.$store.commit('places/setControllerLogs', [])
          this.$emit('close')
        }
      }
    }
  },
  methods: {
    ...mapActions('places', [
      'getControllerFirmwareList',
      'sendGateControllerCommand'
    ]),
    updateFirmware() {
      this.$confirm(this.$vuetify.lang.t('$vuetify.CAN_NOT_BE_UNDONE'), {
        title: this.$vuetify.lang.t('$vuetify.ARE_YOU_SURE'),
        color: 'error',
        icon: 'mdi-alert',
        persistent: true,
        buttonTrueText: this.$vuetify.lang.t('$vuetify.YES'),
        buttonFalseText: this.$vuetify.lang.t('$vuetify.CANCEL')
      }).then(option => {
        if (option === true) {
          this.sendGateControllerCommand({
            placeId: this.controller.PlaceId,
            controllerId: this.controller.Id,
            sendMode: 'NETWORK',
            command: 'FIRMWARE_UPDATE',
            firmwareUrl: this.selectedFirmware.Url
          })
        }
      })
    }
  }
}
</script>
